/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Summerocccoolingtemperaturesetpoint4Inputs */



/**
* | output |
* | --- |
* | "Summer occupied cooling setpoint" |
*
* @param {Ahu_History_Key_Summerocccoolingtemperaturesetpoint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_summerocccoolingtemperaturesetpoint4 = /** @type {((inputs?: Ahu_History_Key_Summerocccoolingtemperaturesetpoint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Summerocccoolingtemperaturesetpoint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer occupied cooling setpoint")
	return /** @type {LocalizedString} */ ("Consigne froid occupation été")
});
export { ahu_history_key_summerocccoolingtemperaturesetpoint4 as "ahu_history_key_summerOccCoolingTemperatureSetpoint" }